/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect } from "react";

import { abortPreviousRequestsIfAny, getUsageUrlKey } from "@/abort";
import { config } from "@/config";
import {
  BillFrequencyEnum,
  IV1UsagePostRequest,
  WhenEnergyUsedMostEnum,
  v1UsagePost,
} from "@contract/electrify-v1";
import { useApi } from "@/hooks/useApi";
import { getSessionId } from "@/utils/sessionId";

export const useUsagePattern = () => {
  const { call } = useApi();

  const makeRequest = async (data: IV1UsagePostRequest) => {
    const result = await call(() => v1UsagePost(config.apiBasePath, data));

    return result;
  };

  useEffect(() => {
    return () => {
      abortPreviousRequestsIfAny(getUsageUrlKey());
    };
  }, []);

  return {
    fetchUsage: async (
      billAmount: number,
      billFrequency: BillFrequencyEnum,
      whenEnergyUsedMost: WhenEnergyUsedMostEnum
    ) => {
      return await makeRequest({
        billAmount,
        billFrequency,
        whenEnergyUsedMost,
        sessionId: getSessionId(),
      });
    },
  };
};
